const labeli18n = {
    es: {
      formulario: {
        campo_obligatorio: 'El campo es requerido',
        error_captcha: 'Verificador incorrecto'
      },
      app: {
        usuario: 'Usuario.',
        password: 'Contraseña',
        ingresar: 'Ingresar',
        new_password:'Escriba su nueva contraseña',
        re_password:'Repita su nueva contraseña',
        reestrablecer_password: 'Reestablecer contraseña',
        acceso_restringido: 'Acceso Restringido',
        login:'Control de Acceso',
        bienvenido: 'Bienvenid@',
        seleccion_sistema: 'Sistemas Disponibles',
        catastro: 'Catastro',
        supervision_control: 'Supervisión y Control',
        fusion_liquidacion: 'Fusión/Liquidación',
        organizaciones_asignadas: 'Organizaciones Asignadas',
        seleccione_organizaciones_asignadas: 'Seleccione de Organizaciones asociadas',
        razon_social: 'Razón Social',
        ruc: 'RUC',
        cambiar_sistema: 'Cambiar de Sistema',
        cambiar_organizacion: 'Cambiar de Organización',
        cambiar_password: 'Cambiar contraseña',
        no_sistemas: 'Usuario sin accesos'
      },
      date: {
        long: 'MMMM Do, YYYY'
      },
      export: 'Export %{count} items',
      export_0: 'Nothing to export',
      export_1: 'Export %{count} item',
      two_lines: 'Line 1<br />Line 2',
      literal_two_lines: 'Line 1\
  Line 2'
    },
    nl: {
      application: {
        title: 'Toffe app met i18n!',
        hello: 'Hallo, %{name}!'
      },
      date: {
        long: 'D MMMM YYYY'
      },
      export: 'Exporteer %{count} dingen',
      export_0: 'Niks te exporteren',
      export_1: 'Exporteer %{count} ding',
      two_lines: 'Regel 1<br />Regel 2',
      literal_two_lines: 'Regel 1\
  Regel 2'
    }
  };

export default labeli18n;